export var ZeroEtlJobsSortField;
(function (ZeroEtlJobsSortField) {
    ZeroEtlJobsSortField["ZERO_ETL_JOBS_SORT_FIELD_CREATED_TIME"] = "CREATED_TIME";
    ZeroEtlJobsSortField["ZERO_ETL_JOBS_SORT_FIELD_START_TIME"] = "START_TIME";
    ZeroEtlJobsSortField["ZERO_ETL_JOBS_SORT_FIELD_END_TIME"] = "END_TIME";
    ZeroEtlJobsSortField["ZERO_ETL_JOBS_SORT_FIELD_STATUS"] = "STATUS";
})(ZeroEtlJobsSortField || (ZeroEtlJobsSortField = {}));
